import { ThemeSelectors } from "@at/design-system-foundation";
import styled from "styled-components";

export const GalleryModalGridStyles = styled.div`
  width: 100%;
  position: relative;

  ul {
    max-width: 900px;
    height: 100%;
    margin: 0 auto;
    padding: 0 ${({ theme }) => ThemeSelectors.getGroupThreeSpacing(theme)};
  }

  li {
    width: 50%;
    display: inline-flex;
    position: relative;
    float: left;
    padding: 5px;
    @media (min-width: 768px) {
      padding: ${({ theme }) => ThemeSelectors.getGroupTwoSpacing(theme)};
    }
    & .image-gallery-item {
      cursor: pointer;
    }
  }

  li:nth-child(3n - 2) {
    width: 100%;
    margin: 0;
  }

  li:first-child {
    padding-top: 0;
  }

  .hidden {
    display: none;
  }
`;
